module.exports = require('./impl').anyIterableConcurrent
